<section class="preview" [attr.aria-label]="data.title + ' details'">
  <header>
    <strong>{{ data.title }}</strong>
    <button type="button" aria-label="Close detail preview" (click)="dialog.close()">Close</button>
  </header>
  <div class="content" [attr.aria-busy]="loading">
    <div *ngIf="loading" class="loading" role="status" aria-live="polite">
      <span class="spinner" aria-hidden="true"></span>
      <span>Loading details&hellip;</span>
    </div>
    <div *ngIf="error" class="error" role="alert">
      <p>{{ error }}</p>
      <button type="button" (click)="load()">Try again</button>
    </div>
    <iframe *ngIf="src" #frame [src]="src" [title]="data.title" [class.loading-frame]="loading"
      referrerpolicy="no-referrer" loading="eager" (load)="frameLoaded(frame)" (error)="frameFailed()"></iframe>
  </div>
</section>
